import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Container from '../../../../Core/Container';

export const StyledContainer = styled(Container)`
  width: 100%;
  overflow-x: hidden;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
  }
`;

export const Heading = styled.h2`
  margin-bottom: 1.5rem;
  text-align: ${({ headingAlignment }) => headingAlignment || 'left'};
`;
